"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sendPostback;
exports.SEND_POST_BACK = void 0;
var SEND_POST_BACK = 'WEB_CHAT/SEND_POST_BACK';
exports.SEND_POST_BACK = SEND_POST_BACK;

function sendPostback(value) {
  return {
    type: SEND_POST_BACK,
    payload: {
      value: value
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NlbmRQb3N0QmFjay5qcyJdLCJuYW1lcyI6WyJTRU5EX1BPU1RfQkFDSyIsInNlbmRQb3N0YmFjayIsInZhbHVlIiwidHlwZSIsInBheWxvYWQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSxjQUFjLEdBQUcseUJBQXZCOzs7QUFFZSxTQUFTQyxZQUFULENBQXNCQyxLQUF0QixFQUE2QjtBQUMxQyxTQUFPO0FBQ0xDLElBQUFBLElBQUksRUFBRUgsY0FERDtBQUVMSSxJQUFBQSxPQUFPLEVBQUU7QUFBRUYsTUFBQUEsS0FBSyxFQUFMQTtBQUFGO0FBRkosR0FBUDtBQUlEIiwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU0VORF9QT1NUX0JBQ0sgPSAnV0VCX0NIQVQvU0VORF9QT1NUX0JBQ0snO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzZW5kUG9zdGJhY2sodmFsdWUpIHtcbiAgcmV0dXJuIHtcbiAgICB0eXBlOiBTRU5EX1BPU1RfQkFDSyxcbiAgICBwYXlsb2FkOiB7IHZhbHVlIH1cbiAgfTtcbn1cblxuZXhwb3J0IHsgU0VORF9QT1NUX0JBQ0sgfTtcbiJdfQ==